import * as React from "react";
import { useMemo, useState } from "react";
import { Button, ThemeProvider } from "@mui/material";
import { t } from "i18next";
import { CreatePalletDialog } from "./create-pallet-dialog";
import { VPUITheme } from "../../../../common/theme/vpui-theme";
import { useWarehouseContext } from "../warehouse-context/warehouse-context-provider";
import { DropdownButton, IDropdownOptionItem } from "../../../../common/component/dropdown-button/dropdown-button";
import { context } from "../../../../context/context";
import { PalletType } from "../../../constants/constants";
import { Permission } from "../../../../context/permission";

interface ICreatePalletProps {
    onPalletCreated: () => Promise<void>;
}

export const CreatePallet = (props: ICreatePalletProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [palletType, setPalletType] = useState<PalletType>(context.settings.palletType);
    const warehouseContext = useWarehouseContext();

    const palletTypes = useMemo(() => [
        { label: t("model.pallet.type.regular"), value: "Regular" },
        context.hasPermission(Permission.FeatureEnablingMasterBoxPalletType) && { label: t("model.pallet.type.masterBox"), value: "MasterBox" },
        context.hasPermission(Permission.FeatureEnablingTruckPalletType) && { label: t("model.pallet.type.truck"), value: "Truck" },
    ].filter(Boolean) as IDropdownOptionItem[], []);

    const handlePalletTypeChange = async (selectedOption: IDropdownOptionItem) => {
        await context.updatePalletType(selectedOption.value as PalletType);
        setPalletType(selectedOption.value as PalletType);
    };

    return <>
        <ThemeProvider theme={VPUITheme}>
            <div>
                {context.hasPermission(Permission.FeatureEnablingMasterBoxPalletType) || context.hasPermission(Permission.FeatureEnablingTruckPalletType)
                    ? <DropdownButton key={"create-pallet-button"}
                                variant={"contained"}
                                color={"secondary"}
                                disabled={warehouseContext.code === undefined}
                                defaultOption={{ value: context.settings.palletType } as IDropdownOptionItem}
                                data-testid={"create-pallet-button"}
                                actionButtonLabel={t(`components.pallet.createPalletDialog.openButton.${palletType}`)}
                                dropdownOptions={palletTypes}
                                onDropdownOptionClick={handlePalletTypeChange}
                                onClick={() => setIsDialogOpen(true)} />
                    : <Button key={"create-pallet-button"}
                              variant={"contained"}
                              color={"secondary"}
                              disabled={warehouseContext.code === undefined}
                              data-testid={"create-pallet-button"}
                              onClick={() => setIsDialogOpen(true)}>
                        {t("components.pallet.createPalletDialog.openButtonOld")}
                    </Button>}
            </div>
            {isDialogOpen && warehouseContext.code &&
                <CreatePalletDialog warehouse={warehouseContext.code}
                                    onClose={() => setIsDialogOpen(false)}
                                    onPalletCreated={async () => await props.onPalletCreated()} />}
        </ThemeProvider>
    </>;
};
